import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import { Spinner } from 'components';

import { DeleteProjectSection } from 'apps/project/views/projectDelete';

@inject('routerStore')
@observer
export class GeneralSettings extends React.Component {
  render() {
    const { projectSettingsAppManager } = this.props;
    const { loading } = projectSettingsAppManager;
    if (loading) {
      return <Spinner margin='30px auto 40px' />;
    }
    return (
      <>
        <DeleteProjectSection manager={projectSettingsAppManager} />
      </>
    );
  }
}

GeneralSettings.propTypes = {
  projectSettingsAppManager: PropTypes.object,
};
